import React, { useState, useEffect } from 'react';
import '../styles/CommerceCategory.css';
import pic1 from "../assets/accountancy (1).png";
import pic2 from "../assets/business (1).png";
import pic3 from "../assets/economic (1).png";
import pic4 from "../assets/math.png";
import pic5 from "../assets/comp.png";
import pic6 from "../assets/typing (1).png";
import pic7 from "../sciencelabs/Screenshot 2026-02-11 103207.webp";
import pic8 from "../sciencelabs/Screenshot 2026-02-11 103333.webp";

const CommerceCategory = () => {
  const [currentImageSlide, setCurrentImageSlide] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  // Slider Images Only
  const sliderImages = [
   pic7,
   pic8,
  ];

  // All Subjects
  const subjects = [
    {
      id: 1,
      name: 'Accountancy',
      description: 'Master the principles of financial recording and reporting. Learn double-entry bookkeeping, ledger accounts, and financial statements to understand business finances.',
      icon: pic1,
    },
    {
      id: 2,
      name: 'Business Studies',
      description: 'Explore the fundamentals of business management and entrepreneurship. Study organizational structures, business ethics, marketing, and strategic planning.',
      icon: pic2,
    },
    {
      id: 3,
      name: 'Economics',
      description: 'Understand market forces and economic principles. Study microeconomics, macroeconomics, and international trade to analyze business decisions.',
      icon: pic3,
    },
    {
      id: 4,
      name: 'Mathematics',
      description: 'Apply mathematical concepts to business problems. Master algebra, calculus, and statistics for financial analysis and decision-making.',
      icon: pic4,
    },
    {
      id: 5,
      name: 'Computer Science',
      description: 'Learn digital tools and technologies for modern business. Study programming, databases, and software applications used in commerce.',
      icon: pic5,
    },
    {
      id: 6,
      name: 'Typing',
      description: 'Develop essential clerical and typing skills. Master keyboard proficiency, speed, and accuracy for professional communication and data entry.',
      icon: pic6,
    }
  ];

  // Auto-play slider
  useEffect(() => {
    if (!autoPlay) return;
    
    const interval = setInterval(() => {
      setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [autoPlay, sliderImages.length]);

  const nextSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const prevSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const goToImageSlide = (index) => {
    setAutoPlay(false);
    setCurrentImageSlide(index);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  return (
    <>
      {/* Commerce Banner */}
      <div className="cc-banner-section">
        <div className="cc-banner-overlay"></div>
        <div className="cc-banner-content">
          <h1 className="cc-banner-title">COMMERCE STREAM</h1>
        </div>
      </div>

      {/* Main Commerce Section */}
      <section className="cc-main-section" id="cc-commerce-main">
        {/* About & Slider Container - Side by Side */}
        <div className="cc-about-slider-container">
          {/* Left - About Section */}
          <div className="cc-about-wrapper">
            <div className="cc-description-block">
              <h2 className="cc-section-title">About <span className="cc-title-highlight">Commerce Stream</span></h2>
              <p className="cc-description-text">
                The Commerce stream prepares students for the business world with a comprehensive curriculum in accounting, 
                business management, and economics. Our programs develop practical skills in financial analysis, business 
                operations, and entrepreneurship. Students gain the knowledge and expertise needed to succeed in banking, 
                finance, retail, and corporate sectors.
              </p>
            </div>
          </div>

          {/* Right - Image Slider */}
          <div className="cc-slider-wrapper">
            <div className="cc-image-carousel">
              {/* Image Display */}
              <div className="cc-image-display">
                {sliderImages.map((image, index) => (
                  <div 
                    key={index}
                    className={`cc-image-item ${index === currentImageSlide ? 'cc-image-active' : ''}`}
                  >
                    <img src={image} alt={`Commerce ${index + 1}`} />
                  </div>
                ))}
              </div>

              {/* Navigation Arrows */}
              <button 
                className="cc-image-nav-btn cc-image-nav-prev"
                onClick={prevSlide}
                aria-label="Previous image"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>

              <button 
                className="cc-image-nav-btn cc-image-nav-next"
                onClick={nextSlide}
                aria-label="Next image"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Commerce Subjects Section */}
        <div className="cc-content-section">
          <div className="cc-subjects-container">
            <h3 className="cc-subjects-heading">Our <span className="cc-heading-accent">Subjects</span></h3>
            
            <div className="cc-subjects-grid">
              {subjects.map((subject) => (
                <div 
                  key={subject.id} 
                  className="cc-subject-card"
                >
                  <div className="cc-card-icon">
                    <img src={subject.icon} alt={subject.name}  className="lab-item-iconcc"/>
                  </div>
                  <h4 className="cc-card-title">{subject.name}</h4>
                  <p className="cc-card-desc">{subject.description.substring(0, 80)}...</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CommerceCategory;